import React from "react";
import { Box, Typography } from "@mui/material";
import { Helmet } from "react-helmet-async";
import GradientHeader from "../../components/product/GradientHeader";

const NewsDetail = () => {

  const headtitle = "News";
  const headsubTitle = "ニュース";
  const headsubdec = "ニュース > ニュースの詳細";

  return (
    <>
      <Helmet>
        <title>特長 | Global Japan Network</title>
        <meta property="og:title" content="特長 | Global Japan Network" />
        {/* <meta property="og:description" content="グローバルジャパンネットワークは、信頼性の高いITオフショア開発・オフショアシステム開発を提供。高品質・低コストでビジネスを支援します。" /> */}
        <meta property="og:url" content="https://gjnetwork.jp" />
        <meta property="og:image" content="https://gjnetwork.jp/img/global-japan-og-img.jpg" />
        <link rel="canonical" href={`https://gjnetwork.jp${window.location.pathname}`} />
      </Helmet>
      <GradientHeader
        title={headtitle}
        subTitle={headsubTitle}
        subdesc={headsubdec}
      />
      <div className="max-w-screen-xl mx-auto pb-20 pt-10 px-4 md:px-5 lg:px-0 xl:px-0" style={{background: '#f0f0f0'}}>
          <Box sx={{width: '100%', display: 'flex', gap: '30px', alignItems: 'flex-start', justifyContent: 'center', padding: '80px 0'}}>
              <div style={{width: '70%', padding: '40px', border: '1px solid #f5f5f5', borderRadius: '20px', background: '#F6F6F6', boxShadow: '0px 2px 1px -1px rgba(0,0,0,0.2),0px 1px 1px 0px rgba(0,0,0,0.14),0px 1px 3px 0px rgba(0,0,0,0.12)'}}>
                  <Typography variant="h1" className="usecase-main-title" sx={{fontSize: '30px', fontWeight: 'bold', fontFamily: 'Noto Sans JP, sans-serif',
                    color: '#FF6000',
                    marginBottom: '30px'
                  }}>Lorem Ipsum Dolor</Typography>
                  <div style={{marginBottom: '10px'}}>
                      <Typography variant="h6" sx={{fontSize: '16px', fontWeight: '600'}}>
                          Introduction:
                      </Typography>
                      <Typography>
                          In the ever-evolving world of data analytics, Power BI continues to lead the business intelligence (BI) space. But what keeps it ahead of the curve? Let’s explore five reasons why Power BI remains the go-to choice for organizations worldwide in 2025.
                      </Typography>
                  </div>
                  <div style={{marginBottom: '10px'}}>
                      <Typography variant="h6" sx={{fontSize: '16px', fontWeight: '600'}}>
                          1. AI-Powered Data Insights
                      </Typography>
                      <Typography>
                          With Microsoft’s heavy investment in artificial intelligence, Power BI now offers features like Copilot for report generation, predictive forecasting, and automated data explanations — saving analysts hours of manual work.
                      </Typography>
                  </div>
                  <div style={{marginBottom: '10px'}}>
                      <Typography variant="h6" sx={{fontSize: '16px', fontWeight: '600'}}>
                          2. Seamless Integration with Microsoft Ecosystem
                      </Typography>
                      <Typography>
                          From Excel to Azure, Power BI works effortlessly within the Microsoft ecosystem, ensuring smooth workflows for teams already using Office 365, Teams, and SharePoint.
                      </Typography>
                  </div>
                  <div style={{marginBottom: '10px'}}>
                      <Typography variant="h6" sx={{fontSize: '16px', fontWeight: '600'}}>
                          3. Real-Time Dashboards and Alerts
                      </Typography>
                      <Typography>
                          Power BI's real-time data streaming capabilities allow businesses to track key metrics live and receive alerts when thresholds are met or anomalies occur.
                      </Typography>
                  </div>
                  <div style={{marginBottom: '10px'}}>
                      <Typography variant="h6" sx={{fontSize: '16px', fontWeight: '600'}}>
                          4. Custom Visualization and DAX Language
                      </Typography>
                      <Typography>
                          Power BI supports custom visual components and its robust Data Analysis Expressions (DAX) formula language, empowering analysts to create tailored metrics and interactive reports.
                      </Typography>
                  </div>
                  <div style={{marginBottom: '10px'}}>
                      <Typography variant="h6" sx={{fontSize: '16px', fontWeight: '600'}}>
                          5. Cost-Effective for All Business Sizes
                      </Typography>
                      <Typography>
                          Whether you're a startup or a multinational, Power BI offers flexible pricing models, making powerful BI capabilities accessible to all.
                      </Typography>
                  </div>
                  <div style={{marginBottom: '10px'}}>
                      <Typography variant="h6" sx={{fontSize: '16px', fontWeight: '600'}}>
                          Conclusion:
                      </Typography>
                      <Typography>
                          As organizations continue to prioritize data-driven decision-making, Power BI’s continuous innovation ensures it remains at the forefront of the BI landscape. Whether you’re visualizing sales performance or predicting customer churn, Power BI equips teams with the tools they need to succeed.
                      </Typography>
                  </div>
              </div>
          </Box>
      </div>
    </>
  );
};

export default NewsDetail;
